module.exports = __webpack_public_path__ + "static/img/ls9.ca3a355.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls9.png
// module id = 3DAj
// module chunks = 12